import React, { FunctionComponent } from 'react'
import withTheme from '@sport1/react-elements/withTheme'
import lightTheme from '../../../../../themes/LightTheme'
import { LineProps } from './Types'

const Line: FunctionComponent<LineProps> = ({ direction, theme = lightTheme }) => {
    let line
    if (direction === 'DOWN') {
        line = (
            <line stroke={theme.colors.GRAY50} x1="0" x2="100%" y1="0" y2="100%" strokeWidth="1" />
        )
    } else if (direction === 'UP') {
        line = (
            <line stroke={theme.colors.GRAY50} x1="0" x2="100%" y1="100%" y2="0" strokeWidth="1" />
        )
    } else
        line = <line stroke={theme.colors.GRAY50} x1="0" x2="100%" y1="0" y2="0" strokeWidth="2" />
    return <svg width="100%">{line}</svg>
}
export default withTheme(Line) as FunctionComponent<LineProps>
